import React from 'react';
import { Dialog, Grid } from '@mui/material';
import styles from '../../../../../../../custom/style.module.css';
import {
  CustomButton,
  CustomDialogAction,
  CustomDialogContent,
  CustomDialogTitle,
  CustomInputLabel,
  CustomTextField,
  InputProps,
  StyledCard,
} from '../../../../../../../custom/components';
import { CloseIconBtn, } from 'custom/constants';

const StatusModal = (props) => {
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal==='status'} onClose={props.onClose} maxWidth={'sm'} fullWidth>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
          Define Customs Status
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <form onSubmit={props.saveStatus} onReset={props.onClose} className={styles.w100}>
          <CustomDialogContent>
            {/* 
            <Typography variant='body2' color='primary' mb={2} borderBottom={'1px solid #e8e8e8'}>
              Define the customs status.
            </Typography> */}

            <StyledCard>
              <Grid container spacing={2} className={styles.formGrid}>
                <Grid item xs={12} sm={12}>
                  <CustomInputLabel htmlFor='marked_as_cleared' required>Customs Status Code to mark as cleared</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    autoFocus
                    id='marked_as_cleared'
                    placeholder='Enter Customs Status Code'
                    type='text'
                    onChange={props.onChangeStatus}
                    name='marked_as_cleared'
                    value={props.marked_as_cleared}
                    error={Boolean(props.statusErrors?.marked_as_cleared)}
                    helperText={props.statusErrors?.marked_as_cleared}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <CustomInputLabel htmlFor='marked_as_not_cleared' required>Customs Status Code to mark as not cleared</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    autoFocus
                    id='marked_as_not_cleared'
                    placeholder='Enter Customs Status Code'
                    type='text'
                    onChange={props.onChangeStatus}
                    name='marked_as_not_cleared'
                    value={props.marked_as_not_cleared}
                    error={Boolean(props.statusErrors?.marked_as_not_cleared)}
                    helperText={props.statusErrors?.marked_as_not_cleared}
                  />
                </Grid>
              </Grid>
            </StyledCard>
          </CustomDialogContent>
          <CustomDialogAction className={`${styles.fSpaceBtw}`}>
            <CustomButton variant='contained' type='reset'> Close</CustomButton>
            <CustomButton variant='contained' type='submit'>{'Update'}</CustomButton>
          </CustomDialogAction>
        </form>
      </Dialog>
    </div>
  );
};
export default StatusModal;